import React from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  BuildingOfficeIcon, 
  UserIcon,
  WrenchScrewdriverIcon,
  CogIcon
} from '@heroicons/react/24/outline';

/**
 * Componente para seleccionar el tipo de usuario cuando no se puede determinar automáticamente
 */
export const SelectUserType = () => {
  const navigate = useNavigate();

  const handleUserTypeSelection = (type) => {
    // Guardar el tipo en localStorage para futuras sesiones
    localStorage.setItem('revvly_user_type', type);
    
    // Redirigir según el tipo seleccionado
    switch (type) {
      case 'taller':
        navigate('/onboarding/empresa');
        break;
      case 'cliente':
        navigate('/solicitar-acceso');
        break;
      default:
    }
  };

  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center px-4">
      <div className="max-w-4xl mx-auto text-center">
        {/* Header */}
        <div className="mb-12">
          <div className="flex items-center justify-center mb-6">
            <CogIcon className="h-12 w-12 text-blue-500 mr-3" />
            <h1 className="text-3xl font-bold text-white">Revvly</h1>
          </div>
          <h2 className="text-2xl font-bold text-white mb-4">
            ¿Cómo planeas usar Revvly?
          </h2>
          <p className="text-gray-300 text-lg">
            Selecciona la opción que mejor describe tu situación
          </p>
        </div>

        {/* Opciones */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-3xl mx-auto">
          {/* Opción Taller */}
          <div 
            onClick={() => handleUserTypeSelection('taller')}
            className="bg-gray-800 border-2 border-gray-700 hover:border-blue-500 rounded-xl p-8 cursor-pointer transition-all duration-300 hover:transform hover:scale-105 group"
          >
            <div className="text-center">
              <div className="inline-flex items-center justify-center w-20 h-20 bg-blue-600 rounded-full mb-6 group-hover:bg-blue-500 transition-colors">
                <WrenchScrewdriverIcon className="h-10 w-10 text-white" />
              </div>
              
              <h3 className="text-xl font-bold text-white mb-4">
                Soy Dueño de Taller
              </h3>
              
              <p className="text-gray-300 mb-6 leading-relaxed">
                Quiero administrar mi taller automotriz, gestionar clientes, 
                vehículos, citas y servicios.
              </p>
              
              <div className="space-y-2 text-sm text-gray-400 mb-6">
                <div className="flex items-center justify-center">
                  <BuildingOfficeIcon className="h-4 w-4 mr-2" />
                  Crear y gestionar empresa
                </div>
                <div className="flex items-center justify-center">
                  <UserIcon className="h-4 w-4 mr-2" />
                  Invitar empleados y mecánicos
                </div>
                <div className="flex items-center justify-center">
                  <CogIcon className="h-4 w-4 mr-2" />
                  Configuración completa del sistema
                </div>
              </div>
              
              <button className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-6 rounded-lg transition-colors group-hover:bg-blue-500">
                Configurar mi Taller
              </button>
            </div>
          </div>

          {/* Opción Cliente */}
          <div 
            onClick={() => handleUserTypeSelection('cliente')}
            className="bg-gray-800 border-2 border-gray-700 hover:border-green-500 rounded-xl p-8 cursor-pointer transition-all duration-300 hover:transform hover:scale-105 group"
          >
            <div className="text-center">
              <div className="inline-flex items-center justify-center w-20 h-20 bg-green-600 rounded-full mb-6 group-hover:bg-green-500 transition-colors">
                <UserIcon className="h-10 w-10 text-white" />
              </div>
              
              <h3 className="text-xl font-bold text-white mb-4">
                Soy Cliente
              </h3>
              
              <p className="text-gray-300 mb-6 leading-relaxed">
                Quiero acceder al sistema de un taller existente para ver 
                el historial de mi vehículo y gestionar citas.
              </p>
              
              <div className="space-y-2 text-sm text-gray-400 mb-6">
                <div className="flex items-center justify-center">
                  <CogIcon className="h-4 w-4 mr-2" />
                  Ver historial de servicios
                </div>
                <div className="flex items-center justify-center">
                  <UserIcon className="h-4 w-4 mr-2" />
                  Gestionar mis vehículos
                </div>
                <div className="flex items-center justify-center">
                  <BuildingOfficeIcon className="h-4 w-4 mr-2" />
                  Agendar citas online
                </div>
              </div>
              
              <button className="w-full bg-green-600 hover:bg-green-700 text-white font-semibold py-3 px-6 rounded-lg transition-colors group-hover:bg-green-500">
                Solicitar Acceso
              </button>
            </div>
          </div>
        </div>

        {/* Información adicional */}
        <div className="mt-12 bg-gray-800 rounded-lg p-6 max-w-2xl mx-auto">
          <p className="text-gray-300 text-sm">
            <span className="font-medium text-white">💡 Nota:</span> Si tienes un código de invitación 
            de un taller, selecciona "Soy Cliente" y podrás ingresarlo en la siguiente pantalla.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SelectUserType;